<template>
    <div class="row">
        <div class="col-12">
            <div class="form-group mb-3">
                <label>Categoría : <span class="text-danger">*</span></label>
                <v-autocomplete
                    auto-select-first
                    :items="categories"
                    v-model="data.category"
                    item-text="name"
                    return-object
                    class="form-control"
                    dense
                    hide-details
                    outlined>
                </v-autocomplete>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <div class="form-control">
                    <v-date-picker
                        no-title
                        v-model="data.date"
                        full-width
                        hide-details
                        :min="moment(new Date()).toISOString()"
                        :allowed-dates="allowedDates">
                    </v-date-picker>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      categories: [],
      calendar: [],
      submit: null,
      dates: []
    }
  },
  created () {
    this.onInit()
  },
  methods: {
    onInit: function () {
      this.submit = 'table'
      this.$axios({
        url: '/all/categories',
        method: 'GET'
      })
        .then((resp) => {
          this.categories = resp.data
        })
        .finally((resp) => {
          this.submit = ''
        })
      this.$axios({
        url: '/calendar',
        method: 'GET'
      })
        .then((resp) => {
          this.calendar = resp.data
        })
        .finally((resp) => {
          this.submit = ''
        })
      this.$axios({
        url: '/all/disable/allowed-dates',
        method: 'GET'
      })
        .then((resp) => {
          this.dates = resp.data
        })
        .finally((resp) => {
          this.submit = ''
        })
    },
    allowedDates: function (val) {
      return this.calendar.findIndex((e) => e === val) === -1 && !this.dates.map(Number).includes(new Date(val).getDay())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/steps/Service.vue